module.exports = __webpack_public_path__ + "static/money-cd65a589268763d266274fa428485a73.svg";